// extracted by mini-css-extract-plugin
export default {"container":"_32bpnARK8K6CbOHNCaXbHJ","banner":"_5x0oBB077ovJXk1y4Wbbdf","content":"_63jpyQPJx6fV7x4fLnhuQe","adDisclaimer":"LgPcpfYu8MLHWbdsG3sTL"};